import { toast } from 'react-toastify';

// Map để theo dõi các toast đã hiển thị
const toastHistory = new Map<string, number>();
const TOAST_COOLDOWN = 2000; // 2 giây cooldown giữa các toast giống nhau

// Utility function để hiển thị toast với spam prevention
export const showToast = {
  success: (message: string, options?: any) => {
    const key = `success-${message}`;
    const now = Date.now();
    const lastShown = toastHistory.get(key);
    
    if (!lastShown || now - lastShown > TOAST_COOLDOWN) {
      toastHistory.set(key, now);
      toast.success(message, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        ...options
      });
    }
  },

  error: (message: string, options?: any) => {
    const key = `error-${message}`;
    const now = Date.now();
    const lastShown = toastHistory.get(key);
    
    if (!lastShown || now - lastShown > TOAST_COOLDOWN) {
      toastHistory.set(key, now);
      toast.error(message, {
        position: "top-center",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        ...options
      });
    }
  },

  warning: (message: string, options?: any) => {
    const key = `warning-${message}`;
    const now = Date.now();
    const lastShown = toastHistory.get(key);
    
    if (!lastShown || now - lastShown > TOAST_COOLDOWN) {
      toastHistory.set(key, now);
      toast.warning(message, {
        position: "top-center",
        autoClose: 3500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        ...options
      });
    }
  },

  info: (message: string, options?: any) => {
    const key = `info-${message}`;
    const now = Date.now();
    const lastShown = toastHistory.get(key);
    
    if (!lastShown || now - lastShown > TOAST_COOLDOWN) {
      toastHistory.set(key, now);
      toast.info(message, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        ...options
      });
    }
  }
};

// Function để clear toast history (có thể dùng khi logout)
export const clearToastHistory = () => {
  toastHistory.clear();
};
